// extracted by mini-css-extract-plugin
module.exports = {"circleStyle":"Avatar_circleStyle__sIqYH"};